import React from 'react'
import PropTypes from 'prop-types'
import { Pie } from 'react-chartjs-2'
import { generateData, getElementAtEvent, OPTIONS } from './TicketsPieChartUtils'

export default function TicketsPieChart ({ ticketsData: { totalCount, statusCount } }) {
  const data = generateData(statusCount)
  return (
    <div className='text-center'>
      <h3>{`Today's Tickets (${totalCount})`}</h3>
      {
        totalCount === 0 && (
          <div className='push-down-large'>
            <h2>0 Tickets</h2>
          </div>
        )
      }
      { totalCount > 0 && (
        <div className='push-down-small'>
          <Pie data={data} options={OPTIONS} onElementsClick={getElementAtEvent} />
        </div>
      )}
    </div>
  )
}

TicketsPieChart.propTypes = {
  ticketsData: PropTypes.object.isRequired
}
